const ENUM = {
    // 招聘管理人员
    RECRUIT_MANAGER: {
        name: 'recruitManager',
        label: '招聘管理人员',
        value: '1'
    },
    // 平台管理人员
    ADMIN: {
        name: 'admin',
        label: '平台管理人员',
        value: '2'
    },
    // 招聘人员
    RECRUIT: {
        name: 'recruit',
        label: '招聘人员',
        value: '3'
    },
    // 应聘人员
    CANDIDATE: {
        name: 'candidate',
        label: '应聘人员',
        value: '4'
    },
}

/**
 * 获取所有name数组
 * @returns 包含所有name数组
 */
const getNameArray = () => {
    let arr = []
    for (let key in ENUM) {
        arr.push(ENUM[key].name)
    }
    return arr;
}

export default Object.freeze(ENUM)

/**
 * 通过value获取name
 * @param {String} value
 * @returns 
 */
export const getNameByValue = value => {
    for (let key in ENUM) {
        let node = ENUM[key]
        if (node.value === value) {
            return node.name
        }
    }
}

/**
 * 通过name获取value
 * @param {String} name
 * @returns 
 */
export const getValueByName = name => {
    for (let key in ENUM) {
        if (ENUM[key].name === name) {
            return ENUM[key].value
        }
    }
}

/**
 * 通过value获取label
 * @param {String} value
 * @returns 
 */
 export const getLabelByValue = value => {
    for (let key in ENUM) {
        let node = ENUM[key]
        if (node.value === value) {
            return node.label
        }
    }
}

export const nameArray = getNameArray()